import React from 'react';
import { useSelector } from 'react-redux';
import { PaymentContent, PaymentItem, PaymentIcon, TextWrapper, PaymentContainer } from './styles';
import { Container } from '../../../components/Layout/styles';
import { chooseFixIcon, choosePayIcon, chooseProtectIcon } from '../Icons';
import { Section, TitleH3 } from '../styles';

const Payment = () => {
	const isMobile: boolean = useSelector((state) => state.app.isMobile);

	const CHOOSE_REASONS = [
		{
			id: 0,
			icon: chooseFixIcon,
			boldText: 'Предоплата 100%',
			text: 'Скидка 15% от базовой цены',
		},
		{
			id: 1,
			icon: chooseProtectIcon,
			boldText: 'Предоплата 50%',
			text: 'Скидка 10% от базовой цены',
		},
		{
			id: 2,
			icon: choosePayIcon,
			boldText: 'Оплата по факту',
			text: 'Базовая цена без скидки',
		},
	];

	return (
		<Section id="SectionPayment" type="payment">
			<Container>
				<PaymentContainer>
					<TitleH3 isCenter={!isMobile}>Гибкая система оплаты</TitleH3>

					<PaymentContent>
						{CHOOSE_REASONS.map((item) => (
							<PaymentItem key={item.id}>
								<PaymentIcon>{item.icon}</PaymentIcon>
								<TextWrapper>
									<p>
										<b>{item.boldText}</b>
									</p>
									<p>{item.text}</p>
								</TextWrapper>
							</PaymentItem>
						))}
					</PaymentContent>
				</PaymentContainer>
			</Container>
		</Section>
	);
};
export default Payment;
